import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {queryString} from 'utilities/url';
import railsData from 'utilities/rails-data';
import {noop} from 'utilities/callbacks';
import QuestionsFlow from './questionsFlow';
import ServiceSelectionFlow from './serviceSelectionFlow';
import {submitServiceSelection} from './helpers/step';
import {LEGACY_SERVICE_HANDLE_MAP} from './helpers/services';
import {fetchStep} from '../../actions/steps';
import {setServiceHandle} from '../../actions/service';
import {fetchServiceTaxonomy} from '../../actions/taxonomy';
import {setOrganization, setBrowseContext} from '../../actions/context';

const PARAMS = {
  CONTEXT: 'context',
};

class Workflow extends React.Component {
  serviceExists = serviceHandle => {
    return this.props.services[serviceHandle] !== undefined;
  };

  serviceIsSelectable = serviceHandle => {
    return (
      this.serviceExists(serviceHandle) &&
      this.props.services[serviceHandle].children.length === 0
    );
  };

  componentDidMount() {
    this.props
      .fetchServiceTaxonomy()
      .then(() => {
        const handleFromContext = queryString.parse(location.search)[
          PARAMS.CONTEXT
        ];

        const serviceHandle =
          LEGACY_SERVICE_HANDLE_MAP[handleFromContext] || handleFromContext;

        if (this.serviceExists(serviceHandle)) {
          this.props.setServiceHandle(serviceHandle);
          if (this.serviceIsSelectable(serviceHandle)) {
            submitServiceSelection(serviceHandle);
          }
        }
      })
      .catch(noop);

    if (railsData('direct_match_profile')) {
      this.props.setOrganization(railsData('direct_match_profile'));
    }

    if (this.props.browseContext) {
      this.props.setBrowseContext();
    }
  }

  render() {
    return this.props.completedServiceSelection ? (
      <QuestionsFlow />
    ) : (
      <ServiceSelectionFlow />
    );
  }
}

function mapStateToProps(store) {
  const {
    progress: {completedServiceSelection},
    entities: {services},
  } = store;

  return {
    completedServiceSelection,
    services,
  };
}

const mapDispatchToProps = {
  fetchStep,
  fetchServiceTaxonomy,
  setOrganization,
  setServiceHandle,
  setBrowseContext,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Workflow);

Workflow.propTypes = {
  completedServiceSelection: PropTypes.bool,
  services: PropTypes.object,
  setOrganization: PropTypes.func.isRequired,
  fetchServiceTaxonomy: PropTypes.func.isRequired,
  setServiceHandle: PropTypes.func.isRequired,
  browseContext: PropTypes.bool,
};
